import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/roles";

/**
 * 法人船員権限一覧取得API
 */
export default {
  fetch() {
    return http.get(`${resource}`);
  },
};
